import React, {useContext, useEffect} from 'react'
import './charter.css'
import { Typography } from '@mui/material'
import { NavigatorContext } from '../../contexts/NavigatorContext';

export default function Charter() {
  const {setParam} = useContext(NavigatorContext);
  useEffect(()=>{
    setParam('charter');
  }, [])
  return (
    <div className='charter-card'>
        <div>
            <div className='charter-header'><Typography variant='body2' fontWeight='bold' color='#bbb'>Induldge in an Uber luxirious flight experience.</Typography></div>
            <div className='inner-frame'>
                <div className='frame-img'></div>
                <div className='charterHeading'>
                    <Typography
                    variant='body1'
                    fontWeight='bold'
                    >Ensure zero crowd and max safety with charter flight.</Typography>
                    <div>Now fly on your own terms with charter flight.</div>
                </div>
            </div>
        </div>
    </div>
  )
}
